import { render, staticRenderFns } from "./ConfiguracionCuenta.vue?vue&type=template&id=01b0be32&scoped=true"
import script from "./ConfiguracionCuenta.vue?vue&type=script&lang=js"
export * from "./ConfiguracionCuenta.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionCuenta.vue?vue&type=style&index=0&id=01b0be32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b0be32",
  null
  
)

export default component.exports